'use client';

import React, { memo, useMemo } from 'react';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  const fontSize = Math.max(14, Math.round(size * 0.44));
  const qSize = Math.max(14, Math.round(size * 0.52));

  return (
    <div className={containerClassName} onClick={onClick}>
      <span
        style={{ fontSize: `${fontSize}px`, letterSpacing: '-0.04em', lineHeight: 1 }}
        className="font-black select-none tracking-tighter"
      >
        <span className="text-foreground">therapi</span>
        <span
          style={{
            fontSize: `${qSize}px`,
            background: 'linear-gradient(135deg, var(--primary) 0%, #6366f1 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
          className="font-black"
        >Q</span>
      </span>
    </div>
  );
});

export default AppLogo;
